// extracted by mini-css-extract-plugin
export default {"item":"Routine_item__-zjHg","titleItem":"Routine_titleItem__MSc6+","styledText":"Routine_styledText__Xa5Ms"};